const  gauge_options = [
  { label: "Mały (do 5 unikalnych sku)", value: "small" },
  { label: "Duży (więcej niż 5 unikalnych sku)", value: "big" },
  { label: "Jedynka (1 unikalny sku)", value: "single" },
  { label: "Unikalny produkt (więcej niż 10 sztuk)", value: "unique_product" },
  { label: "Unikalny produkt (max 10 sztuk)", value: "unique_product_limited" },
];

export default gauge_options;
